module.exports = __webpack_public_path__ + "static/media/ABOUT US.c32ffd72.png";